import * as React from 'react';

import * as md5 from 'md5';

interface IProps {
    email: string,
}

export class Gravatar extends React.Component<IProps> {
    public render() {
        const hash = md5(this.props.email);
        return (<img className="gravatar" src={`https://gravatar.com/avatar/${hash}`} />);
    }
}




// WEBPACK FOOTER //
// ./src/components/Gravatar.tsx